import store from "@/store/index";

export interface AppAdministratorOrganizationsRootListFormCreate {
  user_id: string;
  content: {
    name: string;
    address: string;
    city: string;
    country: string;
  };
}

export class AppAdministratorOrganizationsRootListFormCreate implements AppAdministratorOrganizationsRootListFormCreate {
  user_id: string;
  content: {
    name: string;
    address: string;
    city: string;
    country: string;
  };

  constructor() {
    this.user_id = store.getters.getAuthentication.id ?? "";
    this.content = {
      name: "",
      address: "",
      city: "",
      country: "",
    };
  }
}